import React, { Component } from 'react'
import { connect } from "react-redux";
import {push as changeURL} from 'react-router-redux';
import { platformParser, mobileSearchBuiler, webSearchBuilder  } from './uilts'
import {getUrlQeury} from '~/misc/formatUrlquery';
import mapDispatch from '~/misc/mapDispatch';
import Button from '~/components/common/Button';
import css from './index.css'

class EmailCampaign extends Component {
  constructor(props){
    super(props);
    this.state = { 
      display : false,
      downloadLink: "",
      detailLink: ""
    }
  }
  componentWillMount() {
    const query = getUrlQeury();
    const { navigate } = this.props;
    const {campaignLoadId, campaignEmail, campaignQuery, source} = query;

    //Error Hander: turn to frontpage;
    if(!campaignEmail) {
      return navigate('/')
    }

    const platform = platformParser();
    const campaignQueryObj = campaignQuery ?  JSON.parse(window.atob(campaignQuery)) : '';

    if(platform  === 'Android') {
      this.setState({
        display: true,
        detailLink: campaignLoadId ? `truckloads://shipment?id=${campaignLoadId}` : `truckloads://Loadlist_filter?${mobileSearchBuiler(campaignQueryObj)}`,
        downloadLink: "market://details?id=com.truckerpath.truckloads"
      })
      window.location.href =  campaignLoadId ? `truckloads://shipment?id=${campaignLoadId}${source? ("&source="+source) : ""}` : `truckloads://Loadlist_filter?${mobileSearchBuiler(campaignQueryObj)}`;
      
      setTimeout(()=> {
        if(!document.hidden) {
          window.location.href = "market://details?id=com.truckerpath.truckloads"
        }
      }, 2000)


    }else if(platform  === 'Ios') {
      
      this.setState({
        display: true,
        detailLink: campaignLoadId ? `truckloads://shipment?shipmentId=${campaignLoadId}` : `truckloads://Loadlist_filter?${mobileSearchBuiler(campaignQueryObj)}`,
        downloadLink: "itms-apps://itunes.apple.com/gb/app/id1007287939"
      })
      window.location.href =  campaignLoadId ? `truckloads://shipment?shipmentId=${campaignLoadId}` : `truckloads://Loadlist_filter?${mobileSearchBuiler(campaignQueryObj)}`;
      
      setTimeout(()=> {
        if(!document.hidden) {
          window.location.href = "itms-apps://itunes.apple.com/gb/app/id1007287939"
        }
      }, 2000)
    }else {
      campaignLoadId ?  window.location.href = '/loads/'+ campaignLoadId + '?loadSearchQuery=' + campaignQuery +  (source ? ("&source="+source) : "") : window.location.href = "/searchloads?"+ webSearchBuilder(campaignQueryObj) + (source ? ("&source="+source) : "");
    }
  }


  render() {
    const { downloadLink, detailLink,display } = this.state;
    if(!display) {
      return (<div/>)
    } 
    return ( 
      <div className={css.warp}>
        <Button onClick={()=>window.location.href = detailLink }>Open Loads</Button>
        <Button mods={['action']}  onClick={()=>window.location.href = downloadLink} >Download App</Button>
      </div>
    )
  }
}

export default connect(({}) => ({
}), mapDispatch({
  navigate: (props, url) => changeURL(url),
}))(EmailCampaign);


// WEBPACK FOOTER //
// ./src/pages/EmailCampaign/index.js